import {Uuid4, Ulid} from 'id128';

export const convertUUID4toULID = (id: string) => {
  const uuid4AsUuid = Uuid4.fromCanonical(id);
  const uuid4AsUlid = Ulid.fromRaw(uuid4AsUuid.toRaw());
  const ulidString = uuid4AsUlid.toCanonical();

  return ulidString;
};
